import gql from 'graphql-tag';

const FETCH_NEAR_DEVICES_LIST = gql`
  query Query($skip: Int!, $limit: Int!, $latitude: String!, $longitude: String!) {
    fetchNearDevicesListView(skip: $skip, limit: $limit, latitude: $latitude, longitude: $longitude) {
      totalCount
      result {
        latitude
        longitude
        deviceType
        deviceSerialNo
        broker
        hardwareVersion
        isBillable
        version
        status
        simNumber
        networkProvider
        stage
        firmwareVersion
      }
    }
  }
`;

export default FETCH_NEAR_DEVICES_LIST;
